import { fwcColor } from 'foundations-theming/utils/fwc';
import { deepMerge } from '../../utils/deepMerge';
const backgroundColorMapping = {
  /**
   * Overrides
   */
  calypso: fwcColor('fwc-badge-fill-calypso'),
  'candy-apple': fwcColor('fwc-badge-fill-candy-apple'),
  koala: fwcColor('fwc-badge-fill-koala'),
  lorax: fwcColor('fwc-badge-fill-lorax'),
  marigold: fwcColor('fwc-badge-fill-marigold'),
  norman: fwcColor('fwc-badge-fill-norman'),
  oz: fwcColor('fwc-badge-fill-oz'),
  pantera: fwcColor('fwc-badge-fill-pantera'),
  sorbet: fwcColor('fwc-badge-fill-sorbet'),
  thunderdome: fwcColor('fwc-badge-fill-thunderdome'),
  /**
   * Custom
   */
  beta: fwcColor('fwc-badge-fill-beta'),
  free: fwcColor('fwc-badge-fill-free'),
  new: fwcColor('fwc-badge-fill-new'),
  blue: fwcColor('fwc-badge-fill-blue'),
  teal: fwcColor('fwc-badge-fill-teal'),
  'teal-dark': fwcColor('fwc-badge-fill-teal-dark'),
  green: fwcColor('fwc-badge-fill-green'),
  yellow: fwcColor('fwc-badge-fill-yellow'),
  orange: fwcColor('fwc-badge-fill-orange'),
  magenta: fwcColor('fwc-badge-fill-magenta'),
  purple: fwcColor('fwc-badge-fill-purple'),
  red: fwcColor('fwc-badge-fill-red')
};
const borderColorMapping = {
  /**
   * Overrides
   */
  calypso: fwcColor('fwc-badge-border-calypso'),
  'candy-apple': fwcColor('fwc-badge-border-candy-apple'),
  koala: fwcColor('fwc-badge-border-koala'),
  lorax: fwcColor('fwc-badge-border-lorax'),
  marigold: fwcColor('fwc-badge-border-marigold'),
  norman: fwcColor('fwc-badge-border-norman'),
  oz: fwcColor('fwc-badge-border-oz'),
  pantera: fwcColor('fwc-badge-border-pantera'),
  sorbet: fwcColor('fwc-badge-border-sorbet'),
  thunderdome: fwcColor('fwc-badge-border-thunderdome'),
  /**
   * Custom
   */
  beta: fwcColor('fwc-badge-border-beta'),
  free: fwcColor('fwc-badge-border-free'),
  new: fwcColor('fwc-badge-border-new'),
  blue: fwcColor('fwc-badge-border-blue'),
  teal: fwcColor('fwc-badge-border-teal'),
  'teal-dark': fwcColor('fwc-badge-border-teal-dark'),
  green: fwcColor('fwc-badge-border-green'),
  yellow: fwcColor('fwc-badge-border-yellow'),
  orange: fwcColor('fwc-badge-border-orange'),
  magenta: fwcColor('fwc-badge-border-magenta'),
  purple: fwcColor('fwc-badge-border-purple'),
  red: fwcColor('fwc-badge-border-red')
};
const addBorderRadiusCornerValue = ({
  theme,
  styles,
  borderRadiusKey,
  cornerRadius,
  borderRadius
}) => {
  // Default to the overall borderRadius if individual values are undefined
  const value = cornerRadius !== null && cornerRadius !== void 0 ? cornerRadius : borderRadius;
  if (value) {
    styles[borderRadiusKey] = theme.borderRadius[value];
  }
};
export const getBackgroundColorToken = use => {
  var _backgroundColorMappi;
  return (_backgroundColorMappi = backgroundColorMapping[use]) !== null && _backgroundColorMappi !== void 0 ? _backgroundColorMappi : fwcColor('fwc-badge-fill-lorax');
};
export const getBorderColorToken = use => {
  var _borderColorMapping$u;
  return (_borderColorMapping$u = borderColorMapping[use]) !== null && _borderColorMapping$u !== void 0 ? _borderColorMapping$u : fwcColor('fwc-badge-border-free');
};
export const getBadgeStyleOverrides = ({
  use,
  theme,
  borderRadius,
  borderStartStartRadius,
  borderStartEndRadius,
  borderEndStartRadius,
  borderEndEndRadius,
  badgeContext
}) => {
  var _badgeContext$badgeSt;
  const styles = {};
  addBorderRadiusCornerValue({
    theme,
    styles,
    borderRadiusKey: 'borderStartStartRadius',
    cornerRadius: borderStartStartRadius,
    borderRadius
  });
  addBorderRadiusCornerValue({
    theme,
    styles,
    borderRadiusKey: 'borderStartEndRadius',
    cornerRadius: borderStartEndRadius,
    borderRadius
  });
  addBorderRadiusCornerValue({
    theme,
    styles,
    borderRadiusKey: 'borderEndStartRadius',
    cornerRadius: borderEndStartRadius,
    borderRadius
  });
  addBorderRadiusCornerValue({
    theme,
    styles,
    borderRadiusKey: 'borderEndEndRadius',
    cornerRadius: borderEndEndRadius,
    borderRadius
  });
  return deepMerge(Object.assign({}, use !== 'count' ? styles : {}), (_badgeContext$badgeSt = badgeContext === null || badgeContext === void 0 ? void 0 : badgeContext.badgeStyleOverrides) !== null && _badgeContext$badgeSt !== void 0 ? _badgeContext$badgeSt : {});
};